import { render, staticRenderFns } from "./EduTree.vue?vue&type=template&id=051bf52e&scoped=true"
import script from "./EduTree.vue?vue&type=script&lang=js"
export * from "./EduTree.vue?vue&type=script&lang=js"
import style0 from "./EduTree.vue?vue&type=style&index=0&id=051bf52e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051bf52e",
  null
  
)

export default component.exports